import React, { CSSProperties } from 'react';
import styles from './styles.module.css';

export interface DotProps extends React.HTMLAttributes<HTMLSpanElement> {
  active?: boolean;
  activeColor?: string;
  inactiveColor?: string;
  inactiveBorderColor?: string;
}

export const Dot: React.FC<DotProps> = ({
  active = false,
  activeColor,
  inactiveColor,
  inactiveBorderColor,
  style,
  ...props
}) => {
  const inlineStyle = {
    ...style,
    ...(activeColor && { '--dot-active-color': activeColor }),
    ...(inactiveColor && { '--dot-inactive-color': inactiveColor }),
    ...(inactiveBorderColor && {
      '--dot-inactive-border-color': inactiveBorderColor,
    }),
  } as CSSProperties;

  return (
    <span
      className={`${styles.dot} ${active ? styles.active : null}`}
      style={inlineStyle}
      {...props}
    />
  );
};
